/*
    Requires global-helper.js for event dispatcing and sending/fetching data to/from API.
*/

async function addVariantToCart(variantID, quantity = 1, sellingPlan = null, properties = null) {

    const response = await sendRequestToJSONEndpoint("/cart/add.js", JSON.stringify(
        {
            items: [
                {
                    id: variantID,
                    quantity: quantity,
                    selling_plan: sellingPlan,
                    properties: properties
                }
            ]
        }
    ));

    dispatchGlobalEvent("CartUpdated", {
        type: "add",
        variantID: variantID,
        quantity: quantity,
        selling_plan: sellingPlan,
        properties: properties
    });

    return response;

}

async function removeFromCartWithVariant(variantID) {

}

async function removeFromCartWithKey(key) {

}

async function addNoteToCart(note) {

}

async function addDiscountCodesToCart(codes) {

}

async function addAttributesToCart(attributes) {

}

async function clearCart() {

}

async function getCartItems() {

    try {

        const cartResponse = await fetchResponseFromEndpoint("/cart.js");

        if (cartResponse === false) {

            throw new Error("Got invalid response from server.");

        }

        const json = await cartResponse.json();

        return json.items;

    } catch (error) {

        console.error("Failed to fetch cart items.", error);
        return false;

    }

}